// ----------------------------------------------------------------------------
// Component: Footer
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import 'snippets/newsletter-form/newsletter-form';
import 'snippets/icon/icon';
import 'snippets/menu/menu';
import 'sections/newsletter/newsletter';

// Styles
import './_footer.scss';

document.addEventListener('DOMContentLoaded', function() {
    const footer = document.querySelector('.footer');

    const newsletterSelector = footer.querySelector('.form__field--newsletter-selector'); 
    const hiddenCheckbox = footer.querySelector('.newsletter-checkbox');

    if (newsletterSelector) {
        const newsletterSelectorCheckboxes = newsletterSelector.querySelectorAll('input');
        newsletterSelectorCheckboxes.forEach((input) => {
            input?.addEventListener('change', function() {
                if (input.checked) {
                    if (!hiddenCheckbox.value.includes(input.value)) {
                        hiddenCheckbox.value += `,${input.value}`;
                    } 
                } else {
                    const newHiddenCheckboxValue = hiddenCheckbox.value.split`,`.filter((value) => value != input.value);
                    hiddenCheckbox.value = newHiddenCheckboxValue.join`,`;
                }
            });
        });
    }
});